import FilterBarComponent from './filter-bar-component';

/***
 * The side bar on the Enter Data page that contains a series of custom-dropdown components that
 * are used to filter the form that is filled out by the user.
 */
const filterBar = angular
    .module('FacilityData.EnterData.FilterBar', [])
    .component('filterBar', FilterBarComponent)
    .name;

export default filterBar;


// WEBPACK FOOTER //
// ./app/components/enter-data/filter-bar/filter-bar.js